import { TFunction } from 'i18next';
import { VALIDATION } from '../constants';
import { validatePattern } from './validatePattern';
import { validateMaxLength } from './validateMaxLength';
import { validateMinLength } from './validateMinLength';

export function validateFormalName(t: TFunction) {
	return {
		...validatePattern(
			VALIDATION.formalName.pattern,
			t('invalid_symbols', {
				allowedSymbols: VALIDATION.formalName.allowedSymbols,
			}),
		),
		...validateMaxLength(
			VALIDATION.formalName.maxLength,
			t('formal_name_too_long'),
		),
		...validateMinLength(
			VALIDATION.formalName.minLength,
			t('formal_name_too_short'),
		),
	};
}
